// Pure HTTP communication - no business logic
import {AxiosResponse} from "axios";

import {ForgotRequest, LoginRequest, LogoutResponse, ResetRequest, Session} from "@/src/modules/auth/types";
import CoreApi from "@/src/modules/core/api";

const BASE_URL = "auth/secure";

class AuthApi extends CoreApi {
  async login(data: LoginRequest): Promise<AxiosResponse<Session>> {
    return this.post(`${BASE_URL}/login`, data);
  }

  async reset(data: ResetRequest): Promise<AxiosResponse<void>> {
    return this.post(`${BASE_URL}/reset`, data);
  }

  async forgot(data: ForgotRequest): Promise<AxiosResponse<void>> {
    return this.post(`${BASE_URL}/forgot`, data);
  }

  async logout(): Promise<AxiosResponse<unknown>> {
    return this.get(`${BASE_URL}/logout`);
  }
}

export const authApi = new AuthApi();
